import * as React from "react";

const SvgMixpanel = (props, ref) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...{ ...props, ref }}
  >
    <rect width={28} height={28} rx={4} fill="#4F44E0" />
    <circle cx={8} cy={14} r={3} fill="#fff" />
    <circle cx={16} cy={14} r={2} fill="#fff" />
    <circle cx={22} cy={14} r={1} fill="#fff" />
  </svg>
);

export default React.forwardRef(SvgMixpanel);
